import React from "react"

const Github = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    width="21.713"
    height="23.049"
    viewBox="0 0 21.713 23.049"
  >
    <path
      id="Github"
      data-name="Github"
      d="M9,19c-5,1.5-5-2.5-7-3m14,6V18.13a3.37,3.37,0,0,0-.94-2.61c3.14-.35,6.44-1.54,6.44-7A5.439,5.439,0,0,0,20,4.771,5.07,5.07,0,0,0,19.91,1S18.73.65,16,2.48a13.38,13.38,0,0,0-7,0C6.27.65,5.09,1,5.09,1A5.07,5.07,0,0,0,5,4.77,5.44,5.44,0,0,0,3.5,8.55c0,5.42,3.3,6.61,6.44,7A3.37,3.37,0,0,0,9,18.13V22"
      transform="translate(-0.787 0.049)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
)

export default Github
